export const IS_TELEGRAM = window.Telegram?.WebApp?.initData;
